// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kz-0";
export var fileCarousel = "_kz-2";
export var removeFileButton = "_kz-1";